import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import classes from "./Brands.module.css";

import AnimatedTextCharacter from "../../AnimatedTextCharacter";

import one from "../../../assets/partners/1.jpg";
import two from "../../../assets/partners/2.jpg";
import three from "../../../assets/partners/3.jpg";
import four from "../../../assets/partners/4.jpg";
import five from "../../../assets/partners/5.jpg";
import six from "../../../assets/partners/6.jpg";
import seven from "../../../assets/partners/7.jpg";
import { useTranslation } from "react-i18next";

const logos = [one, two, three, four, five, six, seven];

function Brands() {
  const elementRef = useRef(null);
  const isInView = useInView(elementRef, { once: true });
  const { t } = useTranslation();

  return (
    <div className={classes.toolsContainer}>
      <h3 ref={elementRef}>
        <AnimatedTextCharacter text={`${t("Our Successful Story.title")}`} isVisible={isInView} />
      </h3>
      {/* <p>
        Through their individual experiences, our team has been exposed to many
        local and international organisations in the region and across all the
        HR spectrums.
      </p> */}
      {/* <hr width="10%" color="#012d36" size="8" align="left" /> */}

      <div className={classes.gridContainer}>
        {logos.map((tool, index) => (
          <div key={index} className={classes.gridItem}>
            <img src={tool} alt={tool} />
          </div>
        ))}
      </div>

      {/* <hr /> */}
    </div>
  );
}

export default Brands;
